import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";
import { FaPhone, FaEnvelope, FaLocationDot } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTheme } from "../context/ThemeContext";
const originUrl = window.location.origin;

const Footer = () => {
  const { currentCompany } = useSelector(state => state.init);
  const { getBackground, getTextColor, getButtonStyles } = useTheme();

  if (!currentCompany) {
    return (
      <footer style={{ ...getBackground("background") }} className="pt-12 pb-6">
        <div className="w-[85%] mx-auto grid grid-cols-4 lg:grid-cols-2 sm:grid-cols-1 gap-10">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="flex flex-col gap-3">
              <div className="w-32 h-5 bg-gray-300 animate-pulse rounded" />
              {[1, 2, 3].map(j => (
                <div key={j} className="w-full h-4 bg-gray-200 animate-pulse rounded" />
              ))}
            </div>
          ))}
        </div>
      </footer>
    );
  }

  const logo = currentCompany.logo || "";
  const name = currentCompany.name || "Tienda";
  const phone = currentCompany.phone || "";
  const email_support = currentCompany.email_support || "";
  const phone_whatsApp = currentCompany.phone_whatsApp || "";
  const address = currentCompany.address || "";
  const greeting_whatsApp = currentCompany.greeting_whatsApp || "Hola, me gustaría obtener más información";

  const openWhatsApp = () => {
    if (!phone_whatsApp) return;
    window.open(`https://wa.me/${phone_whatsApp}?text=${encodeURIComponent(greeting_whatsApp)}`, "_blank");
  };

  const socials = [
    { icon: <FaFacebookF size={16} />, url: "https://www.facebook.com/share/1FkgDAhPGx/?mibextid=wwXIfr", label: "Facebook" },
    { icon: <FaInstagram size={16} />, url: "https://www.instagram.com/tekos.peru?igsh=MXg0bzZ6ZHAwY2l1aQ%3D%3D&utm_source=qr", label: "Instagram" },
    { icon: <FaTiktok size={16} />, url: "https://www.tiktok.com/@tekos.peru?_t=ZM-8wlJsEKl0vm&_r=1", label: "TikTok" },
  ];

  const linksUtiles = [
    { to: "/shops", label: "Tienda" },
    { to: "/ofertas", label: "Ofertas" },
    { to: "/nosotros", label: "Nosotros" },
    { to: "/nuestras-tiendas", label: "Nuestras Tiendas" },
    { to: "/blog", label: "Blog" },
    { to: "/atencion-al-cliente", label: "Atención al Cliente" },
    { to: "/seguimiento-pedido", label: "Seguimiento de Pedido" },
  ];

  const terminosLinks = [
    { to: "/terminos-y-condiciones", label: "Términos y Condiciones" },
    { to: "/cambios-y-devoluciones", label: "Cambios y Devoluciones" },
    { to: "/politica-de-seguridad-y-privacidad", label: "Seguridad y Privacidad" },
    { to: "/terminos-de-envios", label: "Términos de Envíos" },
    { to: "/libro-de-reclamaciones", label: "Libro de Reclamaciones" },
  ];

  return (
    <footer
      style={{
        ...getBackground("background"),
        ...getTextColor(),
        boxShadow: "0 -8px 32px 0 rgba(164,28,31,0.35), 0 -2px 8px 0 rgba(164,28,31,0.20)",
      }}>

      {/* Cuerpo principal */}
      <div className="w-[85%] mx-auto pt-14 pb-10 grid grid-cols-4 lg:grid-cols-2 sm:grid-cols-1 gap-10 border-b border-white/20">

        {/* Columna 1 - Logo centrado + redes */}
        <div className="flex flex-col items-center text-center gap-5">
          <Link to="/">
            <img src={logo} alt={name} className="h-[70px] w-auto object-contain" />
          </Link>
          <p className="text-sm opacity-80 leading-relaxed">
            Tu tienda de zapatillas y calzado deportivo con las mejores marcas del mercado.
          </p>
          <div className="flex gap-3 mt-1">
            {socials.map((s, i) => (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/20 transition-colors">
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Columna 2 - Links útiles */}
        <div className="flex flex-col gap-4">
          <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/20 pb-2">
            Explorar
          </h3>
          <ul className="flex flex-col gap-2">
            {linksUtiles.map((link, i) => (
              <li key={i}>
                <Link
                  to={link.to}
                  className="text-sm flex items-center gap-2 opacity-80 hover:opacity-100 hover:translate-x-1 transition-all">
                  <FaChevronRight className="text-xs flex-shrink-0" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Columna 3 - Términos */}
        <div className="flex flex-col gap-4">
          <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/20 pb-2">
            Términos y Políticas
          </h3>
          <ul className="flex flex-col gap-2">
            {terminosLinks.map((link, i) => (
              <li key={i}>
                <Link
                  to={link.to}
                  className="text-sm flex items-center gap-2 opacity-80 hover:opacity-100 hover:translate-x-1 transition-all">
                  <FaChevronRight className="text-xs flex-shrink-0" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/libro-de-reclamaciones" className="mt-2 block hover:opacity-90 transition-opacity">
            <img
              className="w-[150px] h-auto"
              src={`${originUrl}/images/Libroreclamaciones.jpg`}
              alt="Libro de Reclamaciones"
            />
          </Link>
        </div>

        {/* Columna 4 - Contacto + Newsletter */}
        <div className="flex flex-col gap-4">
          <h3 className="font-bold text-base uppercase tracking-wide border-b border-white/20 pb-2">
            Contacto
          </h3>
          <ul className="flex flex-col gap-3">
            {phone && (
              <li className="flex items-center gap-3 text-sm opacity-80">
                <FaPhone className="flex-shrink-0" />
                <span>{phone}</span>
              </li>
            )}
            {email_support && (
              <li className="flex items-center gap-3 text-sm opacity-80">
                <FaEnvelope className="flex-shrink-0" />
                <span>{email_support}</span>
              </li>
            )}
            {address && (
              <li className="flex items-start gap-3 text-sm opacity-80">
                <FaLocationDot className="flex-shrink-0 mt-0.5" />
                <span>{address}</span>
              </li>
            )}
          </ul>

          <div className="mt-2">
            <p className="text-sm font-semibold mb-3">Suscríbete a nuestras ofertas</p>
            <div className="relative">
              <input
                className="h-11 w-full bg-white/10 border border-white/30 rounded-lg px-4 pr-28 outline-none focus:border-white/60 text-sm placeholder-white/50"
                type="email"
                placeholder="Tu correo electrónico"
              />
              <button
                style={getButtonStyles("primary", "white")}
                className="absolute right-1 top-1 h-9 px-3 font-bold text-xs rounded-md transition-colors">
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="w-[85%] mx-auto py-5 flex flex-wrap justify-between items-center gap-3 sm:justify-center text-sm opacity-70">
        <span>© 2025 {name}. Todos los derechos reservados.</span>
        <span>Hecho con ❤️ en Perú</span>
      </div>

      {/* Botón flotante WhatsApp */}
      {phone_whatsApp && (
        <div
          onClick={openWhatsApp}
          title="Contactar por WhatsApp"
          className="fixed bottom-32 right-3 w-14 h-14 sm:w-12 sm:h-12 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center cursor-pointer shadow-lg z-50 border-2 border-white transition-colors">
          <FaWhatsapp className="text-white text-2xl sm:text-xl" />
        </div>
      )}
    </footer>
  );
};

export default Footer;
